<template>
  <div class="row main content-block">
      <div class="container-fluid">

          <div class="row center-block" v-show="noLinkedItemError">
              <h1>Error</h1>
              <p>There is no CLA to sign for {{params.owner}}/{{params.repo}}</p>
              <p>({{noLinkedItemError}})</p>
          </div>

          <el-form class="row" v-show="!noLinkedItemError && !isLoading && !redirect" :model="form" :rules="rules" ref="form">
              <h4 v-show="!signed">Please sign the CLA for {{params.owner}}/{{params.repo}}</h4>
              <h4 v-show="signed">You have signed the CLA for {{params.owner}}/{{params.repo}}</h4>
              <div class="cla-box well">
                  <div v-html="cla"></div>
                  <div class="sign" v-show="cla">
                      <br>
                      <div>Signature:
                        <img :src="signatureImg" v-if="signed" width="250" height="100">
                      </div>
                      <br>
                      <div>Date: <strong style="margin-left:10px">{{date | dateFilter}}</strong></div>
                  </div>
              </div>
              <p style="color:#222222; margin-top: 10px; line-height:20px">
                  Tencent will process your data outside the European Economic Area (“EEA”, namely in the People’s Republic of China) in order to accept your contribution to a Tencent Open Source Project. If you are an EU data subject, your consent is required as the lawful basis for Tencent to transfer your data outside the EEA. Please note that there are risks in such a transfer including your data being subject to differing legal regimes which may not afford it the same level of protection as that available in the country in which you are located. Notably, there is no supervisory authority in the PRC and you will not have all of the same rights as regards your personal data as you would in the EEA.
                  <br>For more information please see Tencent’s Open Source Projects privacy policy
                  <a class="highlighted-link" :href="EUPrivacyUrl" target="_blank" style="color: #0594c6;">here</a> <i>(for EU data subjects only)</i>, Chinese privacy policy
                  <a class="highlighted-link" href="https://privacy.qq.com" target="_blank" style="color: #0594c6;">here</a> <i>(for users who reside in the People's Republic of China)</i> and general international privacy policy
                  <a class="highlighted-link" href="https://privacy.qq.com/yszc-en.htm" target="_blank" style="color: #0594c6;">here</a> <i>(for users located in other jurisdictions)</i>.
                  <br>By clicking on “Agree” below, you agree to the transfer of your data outside the EEA， confirm that you have read and agreed to the appropriate privacy policy and understand how it applies to your contribution to a Tencent Open Source Project and confirm that you are at least 16 years of age.
              </p>
              <el-form-item prop="agreeRadio" ref="agreeRadio" v-if="!!user.data.login && !signed">
                  <el-radio-group v-model="agreeRadio">
                    <el-radio :label="1">agree</el-radio>
                    <el-radio :label="2">disagree</el-radio>
                  </el-radio-group>
              </el-form-item>
              <div style="margin-top:20px" v-if="!!user.data.login && !signed">
                <div>
                  <el-form-item prop="name" ref="name">
                    <p>Name of Individual or Corporation *</p>
                    <el-input v-model="form.name"></el-input>
                  </el-form-item>
                </div>
                <div>
                  <el-form-item prop="email" ref="email">
                    <p>E-Mail *</p>
                    <el-input v-model="form.email"></el-input>
                  </el-form-item>
                </div>
                <div>
                  <el-form-item prop="telephone" ref="telephone">
                    <p>Telephone *</p>
                    <el-input v-model="form.telephone"></el-input>
                  </el-form-item>
                </div>
                <div>
                  <el-form-item prop="login" ref="login">
                    <p>Github Account *</p>
                    <el-input v-model="form.login" disabled></el-input>
                  </el-form-item>
                </div>
                <el-form-item prop="signature" ref="signature">
                  <p>Signature * <span class="text-smaller">(Draw your signature with your mouse)</span></p>
                  <div style="width:500px;background:#fff">
                    <canvas id="canvas" class="signature-pad" width="500" height="200" ></canvas>
                    <div>
                      <el-button size="mini" @click="clear">clear</el-button>
                      <el-button size="mini" @click="undo">undo</el-button>
                    </div>
                  </div>
                </el-form-item>
              </div>
              <p v-show="!!user.data.login && !signed">
                <a class="btn btn-info btn-lg" v-show="!signed && linkedItem && cla && user" @click="_agree('form')">I agree</a>
              </p>
              <p v-show="!user.data.login">
                <a class="btn btn-info btn-lg" @click="_signIn">Sign in with Github to agree</a>
              </p>
          </el-form>
          <div class="loading-indicator" v-show="isLoading && !redirect">
              <img src="/static/images/link_inactive.svg" class="center-div spin-img ">
          </div>

          <div class="row center-block" v-show="signed && !!redirect">
            <h3>Thank you {{this.user.data.login}}</h3>
            <h4>for signing the CLA!</h4>
            </br>
            <h4 v-show="!!redirect">we are now taking you back to GitHub</h4>
            <div>
              <p v-for="n in 3" :key="n" class="fa fa-circle dots" :class="'counter'+n"></p>
            </div>
          </div>
      </div>
  </div>
</template>

<script>
import {getGistContent2, dataURLToBlob} from '@/util/util'
import {getLinkedItem, checkCLA, getLastSignature, getUserEmail, agree} from '@/api/cla'
import {getUserFromGithub} from '@/api/home'
import SignaturePad from 'signature_pad'
export default {
  data() {
    var validateAgree = (rule, value, callback) => {
      //Sconsole.log('validateAgree');
      if (this.agreeRadio != '1') {
        return callback(new Error('please agree the privacy policy'));
      }
      callback();
    };
    var validateSignautre = (rule, value, callback) => {
      //console.log('validateSignautre');
      if(!this.signaturePad || this.signaturePad.isEmpty()){
        return callback(new Error('please draw your signature'));
      }
      callback();
    };
    return {
      agreeRadio:2,
      redirect:null,
      isLoading:true,
      SignatureUrl:null,
      signaturePad:null,
      date:'',
      noLinkedItemError:false,
      signed:false,
      privacyPolicyAccepted:false,
      isSharedSignature: false,
      hasCustomFields:false,
      customFields: {},
      customKeys:[],
      linkedItem:{},
      cla:'',
      params:{
        owner:this.$route.params.owner,
        repo:this.$route.params.repo,
        pullRequest:this.$route.query.pullRequest
      },
      user:{
        data:{
          login:''
        }
      },
      form:{
        name:'',
        email:'',
        telephone:'',
        login:''
      },
      rules: {
        agreeRadio:[
          { validator: validateAgree, trigger: 'change' }
        ],
        name:[
          { required: true, message: 'please enter your name', trigger: 'change' }
        ],
        email:[
          { required: true, message: 'please enter your email', trigger: 'change' },
          { pattern:/^\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}$/, message: 'please enter your valid email!'}
        ],
        telephone:[
          { required: true, message: 'please enter your telephone', trigger: 'change' },
        ],
        login:[
          { required: true, message: 'please enter your github account', trigger: 'change' },
        ],
        signature:[
          { validator: validateSignautre, trigger: 'change' }
        ]
      }
    }
  },
  created() {
    this._initCla()
  },
  methods: {
    _initCla() {
      this.isLoading = true
      Promise.all([this._getLinkedItem(), this._getUser()]).then(() => {
        if (this.user.data.login != '' && this.linkedItem) {
          // 用户已通过oAuth和github认证，并且该项目配置了cla
          this._checkCLA().then(() =>{
            if (this.signed) {
              this.getSignedValues();
            } else {
              this.getGithubValues();
              this.canvasInit();
            }
          })
        }
        this.isLoading = false
      })
    },
    _getLinkedItem() {
      return new Promise((resolve, reject) =>{
        let data = {
          owner: this.params.owner,
          repo: this.params.repo
        }
        getLinkedItem(data).then((res) =>{
          this.linkedItem = res;
          if (this.linkedItem) {
              this.getCLA().then(() =>{
                resolve()
              });
          }
        }).catch((err) =>{
          console.error('getLinkedItem error:', err);
          this.noLinkedItemError = err.message || err
        })
      })
    },
    getCLA() {
      return getGistContent2(this.linkedItem.repoId, this.linkedItem.orgId).then((gistContent) =>{
        this.cla = gistContent.claText.replace(/Signature\:|Date\:/g, '')
        if(gistContent.hasCustomFields) {
          this.customFields = gistContent.customFields;
          this.customKeys = gistContent.customKeys;
          this.hasCustomFields = gistContent.hasCustomFields;
        }
        return
      })
    },
    _getUser() {
      return getUserFromGithub().then((res) => {
        if (!res || !res.data || !res.data.login) {
          throw new Error('Failed to get user info from GitHub');
        }
        this.user = res;
        return res;
      }).catch(err => {
        console.error('Get user error details:', {
          status: err.response && err.response.status,
          data: err.response && err.response.data,
          message: err.message
        });
        // throw err;
      });
    },
    _checkCLA() {
      let data = {
        owner: this.params.owner,
        repo: this.params.repo,
        number: this.params.pullRequest
      }
      return checkCLA(data).then((res) =>{
        if(res){
          this.signed = true;
          this.privacyPolicyAccepted = true;
        }else{
          this.signed = false
        }
        return
      })
    },
    getSignedValues() {
      let data = {
        owner: this.params.owner,
        repo: this.params.repo,
        number: this.params.pullRequest
      }
      return getLastSignature(data).then((res) =>{
        if (this.hasCustomFields && res && res.custom_fields) {
            let customFields = res.custom_fields;
            let tempCla = this.cla
            tempCla = tempCla.replace(/Corporation\:/, 'Corporation:<strong>'+customFields.name+'</strong>')
            tempCla = tempCla.replace(/Telephone\:/, 'Telephone:<strong>'+customFields.telephone+'</strong>')
            tempCla = tempCla.replace(/E-Mail\:/, 'E-Mail:<strong>'+customFields.email+'</strong>')
            tempCla = tempCla.replace(/Account\:/, 'Account:<strong>'+customFields.login+'</strong>')
            this.cla = tempCla
        }
        this.date = res.updated_at || res.created_at
        this.isSharedSignature = this._isSharedSignature(res);
        return
      })
    },
    getGithubValues() {
      // 自动填充 email 和 account
      if (this.hasCustomFields && this.user && !this.signed) {
        this.customKeys.forEach((key) => {
          let githubKey = this.customFields[key].githubKey;
          if (githubKey) {
            if (githubKey === 'email' && !this.user.email) {
              this._getUserEmail(key);
            } else {
              this.form[githubKey] = this.user.data[githubKey];
            }
          }
        });
      }
    },
    _getUserEmail(key) {
      getUserEmail().then(res =>{
        res.data.some((email) =>{
            this.form[key] = email.primary ? email.email : this.customValues[key];
            return email.primary;
        });
      }).catch((err) =>{
        this.$message.error(err);
      })
    },
    _isSharedSignature(cla) {
        return cla && !cla.owner;
    },
    isNotEmpty(value) {
        return !!value || value === 0;
    },
    _agree(claForm) {
      this.$refs[claForm].validate((valid, errors) => {
        if (valid) {
          let data = {
            owner: this.params.owner,
            repo: this.params.repo,
            custom_fields: this.form,
            signImg: this.signaturePad.toDataURL("image/png")
          }
          agree(data).then((res) => {
            if (res.message === 'success') {
              // 跳转逻辑：跳转回pr或者项目首页
              this.signed = true;
              this.privacyPolicyAccepted = true;
              this.redirect = 'https://github.com/' + this.params.owner + '/' + this.params.repo;
              if (this.params.pullRequest) {
                this.redirect = this.redirect + '/pull/' + this.params.pullRequest;
              }
              setTimeout(() => {
                window.location.href = this.redirect;
              }, 5000);
            } else {
              this.$message.error('sign error');
            }
          });
        } else {
          // 滚动到未正确输入的位置(最上面一个)
          for (var error in errors) {
            window.scrollTo(0,this.$refs[error].$el.offsetTop);
            break;
          }
          return false;
        }
      });
    },
    canvasInit() {
      let canvas = document.querySelector("#canvas");
      this.signaturePad = new SignaturePad(canvas);
    },
    clear() {
      this.signaturePad.clear()
      this.SignatureUrl = null
    },
    undo() {
      var data = this.signaturePad.toData();

      if (data) {
        data.pop();
        this.signaturePad.fromData(data);
      }
    },
    _signIn() {
      var url = '/signin/' + this.params.owner + '/' + this.params.repo;
      window.location.href = this.params.pullRequest ? url + '?pullRequest=' + this.params.pullRequest : url;
    }
  },
  computed: {
    showSharedGistMsg() {
        return this.linkedItem && this.linkedItem.sharedGist && (!this.signed || (this.signed && this.isSharedSignature));
    },
    signatureImg() {
      return `/getLastSignatureImg/${this.params.owner}/${this.params.repo}`
    },
    EUPrivacyUrl() {
      return '/privacy'
    }
  },
  filters: {
    dateFilter(value) {
      if (!value) return ''
      value = value.toString()
      return value.split('T')[0]
    }
  }
}

</script>
<style scoped>
.signature-pad {
  /* position: relative; */
  width:500px;
  height:200px;
  background-color: white;
}
ol {
    padding-left: 29px;
}
</style>



// WEBPACK FOOTER //
// src/javascript/home/components/template/cla.vue